import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 60vh;
	padding: 2rem;
	text-align: center;
	font-family: "Roboto", sans-serif;
`;

const Title = styled.h1`
	font-size: 1.5rem;
	margin-bottom: 0.5rem;
`;

const Text = styled.p`
	color: #555;
	margin-bottom: 1.5rem;
`;

export function Unauthorized() {
	return (
		<Wrap>
			<Title>Access denied</Title>
			<Text>You don&apos;t have permission to view this page.</Text>
			<Link to="/">Back to dashboard</Link>
		</Wrap>
	);
}

export default Unauthorized;
